"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var IconMore = function IconMore(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#757575"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5,10 C3.9,10 3,10.9 3,12 C3,13.1 3.9,14 5,14 C6.1,14 7,13.1 7,12 C7,10.9 6.1,10 5,10 Z M19,10 C17.9,10 17,10.9 17,12 C17,13.1 17.9,14 19,14 C20.1,14 21,13.1 21,12 C21,10.9 20.1,10 19,10 Z M12,10 C10.9,10 10,10.9 10,12 C10,13.1 10.9,14 12,14 C13.1,14 14,13.1 14,12 C14,10.9 13.1,10 12,10 Z",
    fillRule: "nonzero"
  }));
};

var _default = IconMore;
exports["default"] = _default;